import {SuperObjectModel} from "./super-object-model";

export interface RecordingSegment {
  source_recording_id: string;
  source_media_id: string;
  start: number;
  end: number;
  remarks: string;
  segment_order?: number | null;
}

type OrderableSegment = {segment_order?: number | null; start: number};

// Segments with a segment order come first, by that number. Equal or missing segment orders fall back to start.
export function compareRecordingSegments(a: OrderableSegment, b: OrderableSegment): number {
  const aUnset = a.segment_order == null;
  const bUnset = b.segment_order == null;
  if (aUnset !== bUnset) {
    return aUnset ? 1 : -1;
  }
  return (aUnset ? 0 : a.segment_order - b.segment_order) || a.start - b.start;
}

export interface RecordingSegmentItem {
  context_id: string;
  relation_id?: string;
}

export class Recording extends SuperObjectModel {
  recording_type: any;
  recording_segment?: RecordingSegment | null;
  recording_segments?: RecordingSegmentItem[];
}
